export enum SnoozeType {
  TODAY = 0,
  TOMORROW = 1,
  THIS_WEEK = 2,
  WEEKEND = 3,
  NEXT_WEEK = 4,
}

export enum PreliminaryTaxUpdateResponse {
  Accept = 1,
  Decline = 2,
}
